module.exports = __webpack_public_path__ + "img/Journalism04.54e577b5.png";